import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { SESSION_STRIPE } from "../services/stripes";
import { rgba, useMantineTheme } from "@mantine/core";
import { rgbString } from "@kurkle/color";

export const useStripeConnect = (connectedAccountId: string | undefined) => {
    const [stripeConnectInstance, setStripeConnectInstance] = useState();
    const theme = useMantineTheme();

    useEffect(() => {
        if (connectedAccountId && theme.colors.dark[8]) {
            const fetchClientSecret = async (): Promise<string> => {
                const { client_secret: clientSecret } = await SESSION_STRIPE({ accountId: connectedAccountId });
                return clientSecret;
            };

            setStripeConnectInstance(
                loadConnectAndInitialize({
                    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
                    fetchClientSecret,
                    appearance: {
                        overlays: "dialog",
                        variables: {
                            colorPrimary: "#3b3d5d",
                            colorBackground: "#3b3d5d",
                            colorSecondaryText: "#F7f7f7",
                        },
                    },
                })
            );
        }
    }, [connectedAccountId, theme.colors.dark[8]]);

    return stripeConnectInstance;
};

export default useStripeConnect;